<template>
<div class="newcontainer" >
  <div v-bind:class="{ bigcon: isSuper }">
  <div class="banner">
    <img src="../assets/images/new1.jpg" alt="">
  </div>
  <div class="content">
    <div class="box1">
      <div class="tt">
        超级会员六大特权
      </div>
      <ul>
        <li>
          <div class="img"><img src="../assets/images/new1_1.jpg" alt=""></div>
          <div class="name">自买省钱</div>
        </li>
        <li>
          <div class="img"><img src="../assets/images/new1_2.jpg" alt=""></div>
          <div class="name">分享赚钱</div>
        </li>
        <li>
          <div class="img"><img src="../assets/images/new1_3.jpg" alt=""></div>
          <div class="name">月月收益</div>
        </li>
        <li>
          <div class="img"><img src="../assets/images/new1_4.jpg" alt=""></div>
          <div class="name">终身会员</div>
        </li>
        <li>
          <div class="img"><img src="../assets/images/new1_5.jpg" alt=""></div>
          <div class="name">随时提现</div>
        </li>
        <li>
          <div class="img"><img src="../assets/images/new1_6.jpg" alt=""></div>
          <div class="name">专属客服</div>
        </li>
      </ul>
    </div>
    <div class="box2">
      <div class="box">
        <div class="tt">
          分享宝贝赚消费佣金
        </div>
        <div class="img"><img src="../assets/images/new2_1.jpg" alt=""></div>
      </div>
<!--       <div class="box">
        <div class="tt">
          邀请好友赚推广奖励
        </div>
        <div class="img"><img src="../assets/images/new2_2.jpg" alt=""></div>
      </div> -->
    </div>
  </div>
    <div class="rule">
      <div class="title">规则说明</div>
      <ol>
        <li>1.邀请5名新用户注册花生日记，您可申请升级为超级会员，领券购物可获得消费佣金奖励</li>
        <li>2.消费佣金是指您或您的专属会员使用花生日记APP领券下单并确认收货后，花生日记奖励给您的佣金。</li>
        <li>3.好友通过您的邀请码下载APP并注册成为花生会员后，Ta即永久成为您的花生会员，未来Ta领券下单时产生的消费佣金奖励收入均计入您的账户中；</li>
        <li>4.您或您的花生会员领券下单并确认收货后，您将获得100%消费佣金；</li>
        <li>5.当您的超级会员邀请好友使用花生日记优惠链接下单并确认收货后，Ta将获得100%消费佣金，您还将获得消费佣金的20%作为奖励；</li>
        <li>6.当您的会员取消订单、退货退款、或者因订单异常等情况，系统将会扣除相应佣金；</li>
        <li>7.消费佣金每月25日将结算上一个自然月确认收货的订单，未确认收货的订单将在下月25日结算，结算后的消费佣金将自动计入您的余额中，您可以通过绑定支付宝随时申请提现，申请后收益将在48小时内到账。</li>
      </ol>

     
      <div class="tips"  v-if="isSuper"> 
        <label><input name="check"   type="checkbox" class="checkbox" v-model="isCheck"/> </label> <router-link to='/others?id=31'>阅读并同意《花生日记超级会员服务协议》</router-link></div>
      <div class="tips"  v-else="isSuper"> 
       <router-link to='/others?id=31'>阅读《花生日记超级会员服务协议》</router-link></div>
    </div>
    </div>
    <div class="botbtn" v-if="isSuper" @click="apply()"><!-- <img src="../assets/images/superbtn.jpg" alt=""> --></div>
    <div class="mask" v-if="isMask">
      <div class="dialog">
        <div class="con">{{dia_con}}</div>
        <div class="btn" v-if="dia_btn" @click="isMask = false">好  的</div>
        <div class="btn" v-if="dia_btn1" @click="backhome()"> <a href="http://#link?pager=home" v-if="backhomeUrl">返回首页</a> <span v-else>返回首页</span></div>
      </div>
    </div>
</div>
</template>

<script>
import utils from '../assets/js/utils'
export default {
  name: 'supermember',
  data () {
    return{
      isSuper: false,
      isCheck: false,
      isMask: false,
      dia_con: '',
      dia_btn: true,
      dia_btn1: false,
      token: '',
      version:'',
      backhomeUrl:true
    }
  },
  mounted() {
    document.title = "超级会员"
    // alert(1111)
    // alert(utils.ua.split('token/')[1])
    if(utils.ua.indexOf('token/')>-1){
      this.token = utils.ua.split('token/')[1].split('hsVerison/')[0]
      this.version = utils.ua.split('token/')[1].split('hsVerison/')[1]

    }

    // if(utils.isIos()){
    //    this.$router.push({path: '/novice'})
    //    return
    // }
    // alert(utils.ua.split('token/')[1].split('hsVerison/')[1])
    // alert(utils.gtVersion(this.version,'2.2.4'))
    if(this.token && this.token != 'null'){  //是否有token
      if (this.token.charAt(this.token.length -1) === '3'){

       this.$router.push({path: '/novice'})
      } else{
          window.location.href = './hsnewComers/html/index.html?token='+ this.token
         
      }
    } else{
      this.$router.push({path: '/novice'})
    }
  },
  methods:{
    apply(){
      if (!this.isCheck ){
        this.isMask = true
        this.dia_con = "请先阅读并同意协议"
        this.dia_btn = true
        return
      }
      const formData = new FormData()
      formData.append('token', this.token)
       this.$http({
          method: 'post',
          url: '/mine/upgradeApply',
          data: formData
       }).then((res)=>{
        if(res.data.status === 200){
          console.log(res.data.data.flag)
          if(res.data.data.flag === '1'){
             this.isMask = true
              this.dia_con ='还差一点，继续努力！'
              this.dia_btn = true
          } else if(res.data.data.flag === '2'){
             this.isMask = true
              this.dia_con ='申请成功，将尽快为你升级。'
              this.dia_btn = false
              this.dia_btn1 = true

          } else if(res.data.data.flag === '3'){
             this.isMask = true
              this.dia_con ='正在审核哦，别着急'
              this.dia_btn = true
          } else if(res.data.data.flag === '4'){
             this.isMask = true
              this.dia_con ='系统开了一会儿小差，请稍后再来。'
              this.dia_btn = true
          } else{

            this.isMask = true
            this.dia_con = res.data.msg
            this.dia_btn = true
          }
        }else{
          // alert(res.data.msg)
          this.isMask = true
          this.dia_con = res.data.msg
          this.dia_btn = true
        }
      })
    },
    backhome(){
      if(utils.gtVersion(this.version,'2.2.4')){
        utils.goToApp('backHome','-1')
      } else if(utils.gtVersion(this.version,'2.2.7')){
        utils.goToApp('backhome','-1')
      }
      this.isMask = false
      return
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// .bigcon{position: fixed;top:0; bottom:3rem; left: 0; width: 100%; overflow: auto; }
.newcontainer{
  background: #f7f7f7;  position: relative;
  img{width: 100%}
  .content{
     background: #fff; border-radius: 1.125rem 1.125rem 0 0; padding-top: 1.5rem;
  }
  .tt{
    font-size: 0.7rem; color: #2d2a25; text-align: center; background: url(../assets/images/quiot.png) no-repeat; width: 7.7rem; height: 0.925rem; line-height: 0.925rem; margin:0 auto; background-size:7.7rem 0.925rem;
  }
  .box1 {
    ul{overflow: hidden; padding-bottom: 1.25rem; width: 12.9rem; margin:0 auto;}
    li{
      width: 4.3rem;  margin:1.5rem 0; float: left;
      .img{width: 2.875rem; margin:0 auto;}
      .name{width: 2.875rem;color: #2d2a25; font-size: 0.65rem; text-align:center; margin:0.5rem auto 0;}
    }
  }
  .box2{overflow: hidden;}
  .box{
    padding-top: 1.0rem; background: #fffbec url(../assets/images/new_des.jpg) no-repeat center top;  width: 17.25rem; margin:0 auto; background-size:17.25rem 0.925rem; margin-bottom: 0.5rem;
    .tt{padding-top: 0.675rem; background-position: bottom center;}
    .img{margin:1.0rem 1.5rem;  padding-bottom:  1.125rem;}
  }
  .rule{
    margin-bottom: 2.8rem;
    .title{width: 3.625rem; height: 1.125rem; line-height: 1.125rem; color: #fff; background:#aa9350; font-size: 0.7rem; text-align: center; margin:1.0rem auto;}
    ol{margin:0 1.0rem;}
    li{color: #383535; font-size: 0.7rem; line-height: 1.0rem; margin-bottom: 0.5rem; }
  }
  .tips{
     text-align:center; height: 2rem; line-height: 2rem; font-size:0.65rem;
    a{text-decoration: underline;color:#928a67;}
    // input{background-color: #d5d5d5; width: 0.625rem; height: 0.625rem;-webkit-appearance: none;}
  }
  .botbtn{width: 90%;padding:1% 5% ; text-align: center; position: fixed; bottom:0;  height: 2.5rem;z-index: 9999; background:#fff url("../assets/images/superbtn.jpg") no-repeat center; background-size: 90% ;
  }
  .mask{position: fixed; top:0; left: 0;  width: 100%; height: 100%; background: rgba(0,0,0,.4)}
  .dialog{width: 12rem; height: 6.5rem; position: absolute; left: 50%; top:50%; color:#666; margin-left:-6rem; margin-top: -4rem; background: #fff; border-radius: 0.2rem;
    .con{height: 1.5rem; border-bottom: 0.01rem solid #e5e5e5; padding:1.5rem 1rem; font-size: 0.8rem; text-align: center;}
    .btn{ height: 2rem; line-height: 2rem; text-align: center; font-size: 0.7rem;
      a{display: block}
    }
  }
}

 input[type=checkbox]{  
            font-size:1em;  
            visibility: hidden;  
            position: relative;  
            display: inline-block;  
            width: 0.8rem;  
            height: 0.8rem;  
        }  
        input[type=checkbox]:before{  
            top:12%;  
            display: inline-block;  
            position: absolute;  
            content:' ';  
            visibility: visible;  
            height: 0.8rem;  
            width: 0.8rem;  
            display: block;  
            background: #d5d5d5;  
            background-size: 0.8rem 0.8rem;  
        }  
        input[type=checkbox]:checked:before{  
            content:' ';  
            visibility: visible;  
            height: 0.8rem;  
            width: 0.8rem;  
            background: url("../assets/images/read_check.jpg") no-repeat;  
            background-size: 0.8rem 0.8rem;  
        }  
</style>



// WEBPACK FOOTER //
// src/components/supermember.vue